import React from "react";
import CardTemplate from "../card-template/CardTemplate";

interface CardSkeletonProps {
    className?: string;
}

/**
 * Skeleton loading component for cards
 * Displays a placeholder animation while card data is being fetched
 * Leverages CardTemplate for consistent layout and styling
 */
const CardSkeleton = ({ className = "" }: CardSkeletonProps) => {
    return (
        <CardTemplate className={className}>
            {/* Content skeleton - centered and properly spaced */}
            <div className="flex flex-col gap-4 justify-center pt-10">
                {/* First row - two fields side by side */}
                <div className="flex gap-2">
                    <div className="flex-1 flex flex-col gap-2">
                        <div className="skeleton h-4 w-3/4 bg-base-200"></div>
                        <div className="skeleton h-9 w-full bg-base-200 rounded-lg"></div>
                    </div>
                    <div className="flex-1 flex flex-col gap-2">
                        <div className="skeleton h-4 w-3/4 bg-base-200"></div>
                        <div className="skeleton h-9 w-full bg-base-200 rounded-lg"></div>
                    </div>
                </div>

                {/* Second row - single field */}
                <div className="flex flex-col gap-2">
                    <div className="skeleton h-4 w-1/3 bg-base-200"></div>
                    <div className="skeleton h-9 w-full bg-base-200 rounded-lg"></div>
                </div>

                {/* Third row - two fields */}
                <div className="flex gap-2">
                    <div className="flex-1 flex flex-col gap-2">
                        <div className="skeleton h-4 w-2/3 bg-base-200"></div>
                        <div className="skeleton h-9 w-full bg-base-200 rounded-lg"></div>
                    </div>
                    <div className="flex-1 flex flex-col gap-2">
                        <div className="skeleton h-4 w-3/4 bg-base-200"></div>
                        <div className="skeleton h-9 w-full bg-base-200 rounded-lg"></div>
                    </div>
                </div>

                {/* Fourth row - single field */}
                <div className="flex flex-col gap-2">
                    <div className="skeleton h-4 w-1/4 bg-base-200"></div>
                    <div className="skeleton h-9 w-full bg-base-200 rounded-lg"></div>
                </div>
            </div>
        </CardTemplate>
    );
};

export default CardSkeleton;
